import React from 'react'
import {LobbyImage} from '@colonist/types'
/* eslint-disable no-restricted-imports */
import {getLobbyImagePath} from '../../../../../../code/client/shared/scripts/ui_utils/Utils.ts'
import styles from './UIGameHelpRulesButton.module.scss'
import clsx from 'clsx'
import {useUIGameHelpRulesButtonContext} from './UIGameHelpRulesButtonContext.tsx'

export interface UIGameHelpRulesButtonProps {
    className?: string
}

export const UIGameHelpRulesButton = ({
    className,
}: UIGameHelpRulesButtonProps) => {
    const {showRulesPopup} = useUIGameHelpRulesButtonContext()

    return (
        <div>
            <img
                className={clsx(styles.rulesButton, className)}
                onClick={showRulesPopup}
                src={getLobbyImagePath(LobbyImage.Rulebook)}/>
        </div>
    )
}
